/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktaketemplateListCtrl
 */
angular.module('mercury.modules.stock.stocktaketemplate')
.controller('StockStocktaketemplateListCtrl', ["dialog", "$scope", "$state", "StocktakeTemplates", "title", function(dialog, $scope, $state, StocktakeTemplates, title) {
  title.set('Stocktake Templates');

  $scope.templates = StocktakeTemplates.getAllActive();

  $scope.deleteTemplate = function(template, index) {
    StocktakeTemplates.remove(template)
    .then(function() {
      $scope.templates.splice(index, 1);
    });
  };

  $scope.create = function() {
    $state.go('Stock.StocktakeTemplates.Create', null, {location: 'replace'});
  };
}]);
